import { DiseaseForGridModel } from '../diseaseForGridModel';
import { UserDiseaseHistoryModel } from './userDiseaseHistoryModel';

export class UserDiseaseModel {
  public userId: number;
  public disease: DiseaseForGridModel;
  public userDiseaseHistory: Array<UserDiseaseHistoryModel>;
}